//hamburger menu
function createHamburgerMenu () {

  var $win = $(window);
  var ww = window.innerWidth;
  var currentWidth = window.innerWidth;
  var breakpoint = 1024;

  // ---  横幅が変動した時に実行
//  $win.on('load', function () {
    checkGnavWidth();
//  });

  window.addEventListener("resize", function () {
    // ウインドウ横幅が変わっていない場合
    if ( currentWidth == window.innerWidth ) {
      return false;
    }
    checkGnavWidth();
    currentWidth = window.innerWidth; // 横幅を更新
  });

  // -- toggle action
  $('#toggle').on('click', function () {
    $(this).toggleClass('is-active');
    $('html').toggleClass('open');

    if ( $(this).hasClass('is-active') ) {
      $('#gnavi').addClass('is-active');
      $('#film').addClass('c-blackFilm--visible');
    } else {
      $('#gnavi').removeClass('is-active');
      $('#film').removeClass('c-blackFilm--visible');
    }

    $('#gnavi').slideToggle( function () { // iOSバグ対策
      if( $(this).hasClass('is-active') ) {
        $(this).css('display','block');
      } else {
        //監視解除
        $(this).css('display','none');
      }
    });

    //スマホでスクロールした際に上下のバーが出てきて、高さが変わるのに対応する。
    if( ww <= breakpoint ) {
      var windowInnerHeight = window.innerHeight;
      var headerHeight = $('.l-header__inner').innerHeight(); //variable.scssの「$headerHeight-sp」と同じ値を取得。
      $('.l-navigation__inner').css('height', windowInnerHeight - headerHeight);
    }
  });


  function checkGnavWidth () {
    ww = window.innerWidth;
    $("[data-js='dropDown']").off();
    if( ww > breakpoint ) {
      $('#gnavi').css('display','block');
      $('.l-navigation__inner').css('height', '100%');
    } else {
      $('#gnavi').css('display','none');
      $('#toggle').removeClass('is-active');
      $('html').removeClass('open');
    }
    globalNavInit();
    anchorLift();
  }

  // --- リサイズ時の初期化
  function globalNavInit () {
    if( ww >= breakpoint ) {
      //PC挙動
      $("[data-js='dropDown']").on('click', function(){
        if ($(this).hasClass('is-opened')) {
          $("[data-js='dropDown']").removeClass('is-opened');
        } else {
          $("[data-js='dropDown']").removeClass('is-opened');
          $(this).addClass('is-opened');
        }
      });
    } else {
      //ハンバーガーメニュー挙動
      $("[data-js='dropDown']").on('click', function(){
        if ($(this).hasClass('is-opened')) {
          $(this).removeClass('is-opened');
        } else {
          $(this).addClass('is-opened');
        }
      });
    }
  }

  //スマホでページ内アンカーリンクをクリックした場合、メニューをしまう
  function anchorLift() {
    let target = $('.l-navigation__item > a[href*="#"]');
    target.off();
    clickAnchorScroll();
    target.on('click', function() {
      if( ww <= breakpoint ) {
        $('html').removeClass('open');
        $('#toggle').removeClass('is-active');
        $('#gnavi').removeClass('is-active').slideUp();
        $('#film').removeClass('c-blackFilm--visible');
      }
    });
  }

}
